(ns ycweb.app.website.dlp.widgets.brandreviews
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]))

(rum/defc brand-reviews [_ page {:keys [properties]}]
  (let [{:brand-reviews/keys [reviews show-recommend?]} properties
        {:keys [avg-stars total-reviews avg-stars-class suggest-percent]} reviews]

    [:div.yc-section
     [:div.brand-reviews
      [:div.brand-reviews__avg-stars
       [:div {:class (u/bem :star-rating [(str avg-stars-class)])}]
       [:p.brand-reviews__score
        [:span.brand-reviews__score-pretext
         (:name page)
         " products have an average rating of"]
        [:span.u-hidden-from-view " "]
        [:b (or avg-stars 0)
         " out of 5 stars from " (u/number-format total-reviews) " reviews"
         [:span.u-hidden-from-view "."]]]]

      (when (and show-recommend? (> (or total-reviews 0) 0))
        [:p.product-reviews__meta
         (str suggest-percent)
         "% of customers would recommend"
         [:span.clip-text {:class (u/bem :unclip-text [:m])}
          " this brand to a friend"]
         [:span.u-hidden-from-view "."]])]]))
